import React from 'react';
import logo from '../../assets/gifs/loading.gif';

import './styles.scss';

export const Loading = () => {
    return (
        <div className="black-overlay" style={{ backgroundColor: "rgba(21, 63, 86, 0.8)", position: "fixed" }}>
            <div className="loadingClass">
                <div className="loading-text">
                    <img src={logo} alt="Carregando" />
                </div>
            </div>
        </div>
    )
};